import { SettingsScreen } from '../features/settings/SettingsScreen'
import { useShell } from '../app/outlet'

export function SettingsPage() {
  const { toast } = useShell()
  return <SettingsScreen onToast={toast} />
}
